import { render, staticRenderFns } from "./AttributeStockList.vue?vue&type=template&id=a7f6ffd8"
import script from "./AttributeStockList.vue?vue&type=script&lang=js"
export * from "./AttributeStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7f6ffd8')) {
      api.createRecord('a7f6ffd8', component.options)
    } else {
      api.reload('a7f6ffd8', component.options)
    }
    module.hot.accept("./AttributeStockList.vue?vue&type=template&id=a7f6ffd8", function () {
      api.rerender('a7f6ffd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/attribute-stock/AttributeStockList.vue"
export default component.exports